/**
 * VeylMe — brand-константы.
 *
 * ЕДИНЫЙ источник истины для бренд-строк (CANON A1).
 * Любое упоминание названия / слогана / домена в коде — через импорт отсюда.
 * Смена бренда = правка этого файла; больше нигде менять не нужно.
 *
 * НЕ читает process.env / import.meta.env — это чистые константы, чтобы
 * модуль безопасно импортировался и в Node-окружении (bot/api), и в браузере
 * (miniapp через Vite). Конфигурируемые значения (BOT_USERNAME, MINIAPP_SHORT_NAME)
 * читаются на стороне consumer-а из его собственного env-источника.
 */

export const BRAND_NAME = 'VeylMe';
export const BRAND_SLUG = 'veylme';

// Ru/En — локализация UI начнётся в Вехе 10; пока обе строки лежат рядом.
export const BRAND_TAGLINE_RU = 'Задай мне анонимный вопрос';
export const BRAND_TAGLINE_EN = 'Ask me anonymously';

// Placeholder домена — заменится на реальный после Вехи 11 (deploy).
export const BRAND_DOMAIN = 'veyl.me';
